var _defs, _path, _path2, _rect, _path3, _rect2, _path4, _path5, _path6, _path7, _path8, _path9, _rect3, _rect4, _path10, _path11, _path12, _path13, _rect5, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g, _g2, _g3, _path21, _path22, _path23, _path24, _circle, _g4, _g5, _g6, _g7, _circle2, _circle3, _g8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComebackKid(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "comeback_kid_svg__Illustration",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1040",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".comeback_kid_svg__cls-1{stroke-miterlimit:10;stroke-width:24px}.comeback_kid_svg__cls-1,.comeback_kid_svg__cls-2{fill:#26b8bf}.comeback_kid_svg__cls-1{stroke:#024447}.comeback_kid_svg__cls-5{fill:#f93444}.comeback_kid_svg__cls-6{fill:#fa505e}.comeback_kid_svg__cls-7{fill:#024447}.comeback_kid_svg__cls-8{fill:#006c78}.comeback_kid_svg__cls-10{fill:#fff}.comeback_kid_svg__cls-11{fill:#fd934f}.comeback_kid_svg__cls-13{fill:#fed425}.comeback_kid_svg__cls-15{fill:#1e9561}.comeback_kid_svg__cls-16{fill:#2a848e}.comeback_kid_svg__cls-18,.comeback_kid_svg__cls-19,.comeback_kid_svg__cls-20,.comeback_kid_svg__cls-22{stroke-linecap:round;stroke-linejoin:round;fill:none;stroke-width:16px}.comeback_kid_svg__cls-18{stroke:#fa505e}.comeback_kid_svg__cls-19{stroke:#f93444}.comeback_kid_svg__cls-20{stroke:#006c78}.comeback_kid_svg__cls-22{stroke:#1e9561}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-11",
    d: "M637.79 935.45l88.35-47.09c15.68-8.36 21.67-28.03 13.32-43.71-8.36-15.68-28.03-21.67-43.71-13.32l-95.43 50.86-30.33-4.76 24.09 44.69c8.36 15.68 28.03 21.67 43.71 13.32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-18",
    d: "M568.55 877.59l25.53 44.55c8.36 15.68 28.03 21.67 43.71 13.32l88.35-47.09c15.68-8.36 21.67-28.03 13.32-43.71"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "comeback_kid_svg__cls-8",
    x: 658.54,
    y: 529.66,
    width: 208.23,
    height: 109.89,
    rx: 54.94,
    ry: 54.94
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-5",
    d: "M79.34 693.71h91.5V871.1h-91.5c-22.09 0-40-17.91-40-40v-97.39c0-22.09 17.91-40 40-40zM270.92 460.14h-52.76c-17.62 0-32.03 14.41-32.03 32.03s14.41 32.03 32.03 32.03h52.76c17.62 0 32.03-14.41 32.03-32.03s-14.41-32.03-32.03-32.03zm0 44.06h-52.76c-6.52 0-12.03-5.51-12.03-12.03s5.51-12.03 12.03-12.03h52.76c6.52 0 12.03 5.51 12.03 12.03s-5.51 12.03-12.03 12.03z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "comeback_kid_svg__cls-6",
    x: 85.39,
    y: 490.98,
    width: 232.18,
    height: 380.12,
    rx: 60,
    ry: 60
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-19",
    d: "M138.13 730.7V550.99c0-33.14 26.86-60 60-60"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-16",
    d: "M276.46 756.33v53.29c0 14.23-11.53 25.76-25.76 25.76h-6.02c-14.23 0-25.76 11.53-25.76 25.76 0 14.23 11.53 25.76 25.76 25.76h153.07"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-16",
    d: "M713.14 445.25V766.9c0 62.9-48.41 114.51-110 119.58-3.29.28-6.63.42-10 .42H375.61c-3.37 0-6.71-.14-10-.42-61.6-5.07-110-56.68-110-119.58V445.25c0-126.34 102.42-228.76 228.76-228.76 63.17 0 120.36 25.6 161.76 67 41.4 41.4 67.01 98.59 67.01 161.76z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M622.24 263.42c9.3-3.91 13.66-14.62 9.75-23.92-23.19-55.08-66.51-95.54-117.8-116.44-51.48-20.98-110.97-22.24-166.22 1.21-110.03 46.7-160.65 174.48-114.28 284.65l6.47 15.36 382.08-160.85z",
    fill: "#46c65e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-22",
    d: "M442.18 153.36c-32.86-28.66-66.66-40.71-93.62-29.36-50.54 21.28-59.08 117.26-21.74 219.94M348.56 124.01c-87.42 36.8-138.03 124.31-132.02 213.93"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-16",
    d: "M482.13 223.96h79.33c15.66 0 28.38 12.72 28.38 28.38v17.6H453.75v-17.6c0-15.66 12.72-28.38 28.38-28.38z",
    transform: "rotate(-22.83 521.79 246.952)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "comeback_kid_svg__cls-15",
    x: 305.42,
    y: 108.7,
    width: 71.89,
    height: 31,
    rx: 15.5,
    ry: 15.5,
    transform: "rotate(-22.83 341.366 124.208)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "comeback_kid_svg__cls-15",
    x: 328.57,
    y: 202.77,
    width: 18.92,
    height: 18.92,
    rx: 9.46,
    ry: 9.46,
    transform: "rotate(-22.83 338.03 212.22)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-15",
    d: "M225.82 385.54l-107.41 45.22c-10.31 4.34-15.71 16.05-11.74 26.5 4.17 10.98 16.56 16.22 27.29 11.7l145.88-61.41c-8.84-21-33.02-30.85-54.02-22.01z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-16",
    d: "M319.17 681.27c23.07-53.41 9.18-117.29-36.98-156.01L194.3 639.82v41.45h124.87z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-6",
    d: "M227.53 518.83v11.44c0 10.39 5.9 19.84 15.18 24.5 30.66 15.4 52.17 50.97 52.17 92.3s-21.52 76.9-52.17 92.3c-9.28 4.66-15.18 14.11-15.18 24.5 0 20.35 21.44 33.62 39.62 24.48 48.67-24.45 82.5-78.51 82.5-141.28 0-68.13-39.86-126-95.29-146.89-12.98-4.89-26.83 4.78-26.83 18.64z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-19",
    d: "M294.87 648.94c-.64 40.53-21.97 75.26-52.16 90.43-9.28 4.66-15.18 14.11-15.18 24.5 0 20.35 21.44 33.62 39.62 24.48 48.67-24.45 82.5-78.51 82.5-141.28 0-68.13-39.86-126-95.29-146.89"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "comeback_kid_svg__cls-16",
    x: 183.1,
    y: 617.92,
    width: 225.23,
    height: 109.89,
    rx: 54.94,
    ry: 54.94
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-11",
    d: "M360.42 874.61h100.12c17.83 0 32.31 14.48 32.31 32.31v21.02c0 6.23-5.06 11.29-11.29 11.29H360.42c-17.83 0-32.31-14.48-32.31-32.31 0-17.83 14.48-32.31 32.31-32.31z",
    transform: "rotate(-180 410.485 906.92)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-18",
    d: "M329.12 874.9l-1 32.02c0 17.77 14.54 32.31 32.31 32.31h100.12c17.77 0 32.31-14.54 32.31-32.31"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-16",
    d: "M404.85 349.7c5.97-12.79 16.79-23.33 31.02-28.51 14.23-5.18 29.29-4.07 42.08 1.9l13.04 19.4-75.07 27.41-11.07-20.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-20",
    d: "M477.95 323.09c-12.79-5.97-27.85-7.08-42.08-1.9-14.23 5.18-25.05 15.71-31.02 28.51M595.27 323.09c12.79-5.97 27.85-7.08 42.08-1.9 14.23 5.18 25.05 15.71 31.02 28.51"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-10",
    d: "M653.14 771.3V619.53c0-65.53-52.53-119.69-118.06-120.07-65.81-.39-119.47 53.03-119.47 118.76V771.3c0 41.75 33.85 75.6 75.6 75.6h86.33c41.75 0 75.6-33.85 75.6-75.6z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 20,
    strokeLinejoin: "round",
    fill: "#024447",
    stroke: "#024447",
    d: "M483.28 401.97h140.55v22.77H483.28z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M239.6 424.15l11.14-17.3a30.007 30.007 0 0125.22-13.76h139.16",
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 40,
    stroke: "#024447"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-1",
    d: "M388.73 385.25h105.82c18.21 0 33 14.79 33 33v82.45c0 22.08-17.92 40-40 40h-78.82c-22.08 0-40-17.92-40-40v-95.45c0-11.04 8.96-20 20-20zM603.4 385.25h95.82c11.04 0 20 8.96 20 20v95.45c0 22.08-17.92 40-40 40H610.4c-22.08 0-40-17.92-40-40v-82.45c0-18.21 14.79-33 33-33z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-6",
    d: "M494.54 723.57c-13.24 9.45-31.62-.02-31.62-16.28v-55.35c0-16.26 18.38-25.73 31.62-16.28l20.53 14.65c20.12 14.36 20.12 44.25 0 58.61l-20.53 14.65zM586.21 723.57c13.24 9.45 31.62-.02 31.62-16.28v-27.67-27.67c0-16.26-18.38-25.73-31.62-16.28l-20.53 14.65c-20.12 14.36-20.12 44.25 0 58.61l20.53 14.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-19",
    d: "M488.75 679.62h103.26"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "comeback_kid_svg__cls-6",
    x: 522.22,
    y: 661.46,
    width: 36.32,
    height: 36.32,
    rx: 10,
    ry: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-5",
    d: "M548.54 661.46c5.52 0 10 4.48 10 10v16.32c0 5.52-4.48 10-10 10h-16.32c-5.52 0-10-4.48-10-10v-16.32c0-5.52 4.48-10 10-10h16.32m0-16h-16.32c-14.34 0-26 11.66-26 26v16.32c0 14.34 11.66 26 26 26h16.32c14.34 0 26-11.66 26-26v-16.32c0-14.34-11.66-26-26-26z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-7",
    d: "M461.69 504.02c-13 0-23.57-10.57-23.57-23.57v-39.41c0-13 10.57-23.57 23.57-23.57s23.57 10.57 23.57 23.57v39.41c0 13-10.57 23.57-23.57 23.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-2",
    d: "M471.74 464.2l19.44 11.22c2.67 1.54 6-.38 6-3.46v-22.45c0-3.08-3.33-5-6-3.46l-19.44 11.22c-2.67 1.54-2.67 5.39 0 6.93z"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-7",
    d: "M627.41 504.02c-11.7 0-21.21-10.57-21.21-23.57v-39.41c0-13 9.52-23.57 21.21-23.57s21.21 10.57 21.21 23.57v39.41c0 13-9.52 23.57-21.21 23.57z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-2",
    d: "M618.79 463.93l-17.47 11.21c-2.53 1.62-5.84-.19-5.84-3.19v-22.42c0-3 3.32-4.81 5.84-3.19l17.47 11.21c2.33 1.49 2.33 4.89 0 6.39z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-20",
    d: "M259.02 727.81h94.37c30.22 0 54.94-24.72 54.94-54.94s-24.72-54.94-54.94-54.94H325.8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M138.37 734.92l-10.01 18.35c-4.3 7.88 1.4 17.48 10.38 17.48h0c9.13 0 14.82-9.92 10.2-17.8l-10.56-18.03z",
    stroke: "#fd934f",
    strokeWidth: 16,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "#fd934f"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "comeback_kid_svg__cls-5",
    cx: 138.74,
    cy: 760.36,
    r: 8.06
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "comeback_kid_svg__cls-13",
    x: 483.28,
    y: 488,
    width: 120.2,
    height: 51.32,
    rx: 25.66,
    ry: 25.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-13",
    d: "M483.28 513.66v12.17c0 22.09 17.91 40 40 40h27.86c16.57 0 30-13.43 30-30v-12.17l-97.86-10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.67 534.24h-37.51c-11.17 0-21.57-5.73-27.53-15.18h0",
    stroke: "#fd934f",
    strokeWidth: 16,
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 546.74,
    y: 380.01,
    width: 25.71,
    height: 61.98,
    rx: 12.85,
    ry: 12.85,
    fill: "#c9edef"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "comeback_kid_svg__cls-10",
    x: 526.89,
    y: 380.01,
    width: 25.71,
    height: 61.98,
    rx: 12.85,
    ry: 12.85
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "comeback_kid_svg__cls-7",
    x: 750.62,
    y: 431.18,
    width: 136.73,
    height: 241.92,
    rx: 30,
    ry: 30
  }), /*#__PURE__*/React.createElement("rect", {
    className: "comeback_kid_svg__cls-7",
    x: 780.62,
    y: 431.18,
    width: 136.73,
    height: 241.92,
    rx: 30,
    ry: 30
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-8",
    d: "M871.86 539.13c.23-1.61.26-3.28.05-5-1.04-8.35-7.8-15.04-16.17-15.97-11.13-1.24-20.55 7.43-20.55 18.31 0 .78.05 1.55.14 2.31.79 6.27-.41 12.66-4.01 17.85-3.29 4.74-5.1 10.57-4.78 16.85.69 13.63 11.73 24.8 25.35 25.65 15.76.98 28.85-11.51 28.85-27.06 0-5.47-1.62-10.57-4.41-14.83-3.52-5.38-5.39-11.75-4.46-18.11zM876.1 492.06c-5.6-2.34-12.3-1.24-16.86 3.32s-5.66 11.26-3.32 16.86c5.6 2.34 12.3 1.24 16.86-3.32s5.66-11.26 3.32-16.86z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-20",
    d: "M842.81 431.18h-32.19c-16.57 0-30 13.43-30 30V643.1c0 16.57 13.43 30 30 30h32.19"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-16",
    d: "M870.69 619.24l29.97 17.3c26.67 15.4 60-3.85 60-34.64v-34.61c0-30.79-33.33-50.04-60-34.64l-29.97 17.3c-26.67 15.4-26.67 53.89 0 69.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-20",
    d: "M900.66 532.66l-14.99 8.65-14.99 8.65c-13.33 7.7-20 21.17-20 34.64 0 13.47 6.67 26.94 20 34.64l14.99 8.65 14.99 8.65"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 893.31,
    cy: 457.15,
    r: 9.83,
    fill: "#013133"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "comeback_kid_svg__cls-10",
    cx: 868.94,
    cy: 457.15,
    r: 6.69
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-16",
    d: "M613.11 147.38c-13.29-9.05-31.22-6.44-41.48 5.48-13.95-7.5-31.74-3.37-40.84 10l-51.89 76.19c-.64.94-1.53 1.67-2.57 2.11-14.45 6.08-21.23 22.72-15.15 37.17l6.83 16.23 125.43-52.8c-1.56-3.7-1.14-7.94 1.12-11.26l26.85-39.45c9.72-14.28 5.99-33.93-8.29-43.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "comeback_kid_svg__cls-20",
    d: "M530.79 162.85c9.72-14.28 29.37-18.02 43.65-8.29 14.28 9.72 18.02 29.37 8.29 43.65l-23.85 35.04"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComebackKid);
export default ForwardRef;